// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"bb51825a","161":"a4c5b6c2","183":"6aea567d","272":"11b85557","490":"e60028ba","534":"c5e1ebc1","691":"c9c52682","719":"1b69fcd3","860":"163eac1d"}[chunkId] + ".chunk.js";
};